export enum HitState {
    Idle,
    Started,
    Anticipation,
    Ended
}